import { render, staticRenderFns } from "./AdminClients.vue?vue&type=template&id=244874fd&"
import script from "./AdminClients.vue?vue&type=script&lang=js&"
export * from "./AdminClients.vue?vue&type=script&lang=js&"
import style0 from "./AdminClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/diego/dev/saude-plus/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VContainer,VContent,VFlex,VIcon,VLayout,VSpacer,VTextField,VToolbar,VToolbarItems,VToolbarTitle,VTooltip})
